import { 
    CHANGE_SEARCH_FIELD,
    CATS_INFO_FETCHED,
    CATS_INFO_FETCH_ERROR,
} from "../actions/constants"

const initialStateSearch = {
    searchField: '',
}

export const searchCat = (state = initialStateSearch, action = {}) => {
    switch(action.type){
        case CHANGE_SEARCH_FIELD:
            return { ...state, searchField: action.payload }
        default:
            return state
    }
}

const initialStateFetch = {
    catsList: [],
    isPending: true,
    error: ''
}

export const fetchCatsInfo = (state = initialStateFetch, action = {}) => {
    switch(action.type){
        case CATS_INFO_FETCHED:
            return { ...state, catsList: action.payload, isPending: false }
        case CATS_INFO_FETCH_ERROR:
            return { ...state, isPending: false, error: action.error }
        default:
            return state
    }
}